import { useEffect, useState } from 'react'

const useDimensions = () => {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1200)

  useEffect(() => {
    const onResize = () => {
      setIsDesktop(window.innerWidth >= 1200)
    }

    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])

  return { isDesktop }
}

export default useDimensions
